import {createGlobalStyle} from "styled-components";
import {createTheme} from "@mui/material/styles";

const TextSecondaryColor = "#54595F"
declare module '@mui/material/styles' {
  interface Theme {
    colors: {
      danger: string;
    };
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    colors?: {
      admins?: string,
      warning?: string,
      success?: string,
      text?: string,
      primary?: string,
      secondary?: string,
      accent?: string,
      disabledTransparent?: string
    };
  }
}
const font = "'Montserrat Alternates', sans-serif";

export const theme = createTheme({

  typography: {
    fontFamily: font,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: font,
      },
    },
  },
  palette: {
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#54595F',
    },
    warning: {
      main: '#ffcc00'
    },

    text: {
      primary: '#7A7A7A',
    },
    success: {
      main: '#4caf50'
    }
  },
  colors: {
    admins: 'rgba(255,204,0,0.15)',
    accent: '#690038',
    warning: '#ffcc00',
    success: '#4caf50',
    text: '#7A7A7A',
    primary: '#7A7A7A',
    secondary: '#54595F',
    disabledTransparent: ' #0000008c',
  },
  spacing: (value: number) => {
    return `${8 * value}px`
  }
});


export const GlobalStyles = createGlobalStyle`

  body {
    margin: 0;
    font-family: 'Montserrat Alternates', sans-serif;
    padding: 0;
  }

  a.MuiLink-underlineAlways {
    text-decoration: none;
  }

  * {
    font-family: 'Montserrat Alternates', sans-serif;
  }
`

